<template>
  <div :style="themeStyle">
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card v-if="dialog && use">
        <v-toolbar dark :color=" $bgColor ">
          <v-btn icon dark @click="closeUseReward">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Use Reward</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-list subheader>
          <v-subheader>{{ $t("message.showQrcodeReward") }}</v-subheader>
          <v-divider></v-divider>
        </v-list>
        <v-row>
          <v-col class="text-center headline1 ma-0 pa-0 font24">
            {{ use.rewardCode }}
          </v-col>
        </v-row>
        <v-row>
          <v-col class="text-center">
            <qrcode-usecode
              :shopId="use.shopId"
              :rewardId="use.rewardId"
              :rewardCode="use.rewardCode"
              :lineUserId="profile.userId"
            ></qrcode-usecode>
          </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-row>
          <v-col class="text-center headline1 font20">
            {{ $t("message.rewardDetail") }}
          </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-row>
          <v-col class="d-flex flex-column justify-space-between align-center"
            ><v-img :src="use.pictureUrl" max-width="150"></v-img
          ></v-col>
        </v-row>
        <v-row>
          <v-col class="text-center">
            <v-row class="font16 bold headline1">
              <v-col class="pl-0 pt-2 pb-3">{{ use.name }}</v-col>
            </v-row>
            <v-row class="font14 icon2">
              <v-col class="pl-0 pt-0 pb-3"
                >{{ $t("message.useBefor") }}
                <span class="icon1">{{ use.endDate }}</span></v-col
              >
            </v-row>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogRewardhistory"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      style="border-radius: 10 ! important"
    >
      <v-card>
        <v-toolbar dark :color="$bgColor">
          <v-btn icon dark @click="dialogRewardhistory = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ $t("message.rewardHistory") }}</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-list three-line subheader>
          <v-list-item
            v-for="(item, i) in rewardHistory"
            :key="i"
            class="pl-0 pr-0"
          >
            <v-list-item-content style="border-bottom: solid #e5e0e0;">
              <v-col cols="4" style="padding-top: 10px" align="center">
                <img
                  :src="item.pictureUrl"
                  style="
                    width: 95px;
                    height: 95px;
                    border-radius: 20px;
                    border-style: solid;
                    border-color: #eeee;
                  "
                  class="link"
                />
              </v-col>
              <v-col cols="8" class="pl-0 pr-0">
                <div class="font16 bold mt-1">
                  <v-col class="pa-0 mb-1">{{ item.name }}</v-col>
                  <v-col class="pa-0 mb-1" v-if="item.supply === 'จัดส่ง'"
                    >{{ $t("message.type") }}: <v-icon>mdi-cube-send</v-icon>
                    {{ item.supply }}</v-col
                  >
                  <v-col class="pa-0 mb-2" v-if="item.supply === 'จัดส่ง'"
                    >{{ $t("message.deliveryLocation") }}: {{ item.houseNumber }}, ต.{{
                      item.subDistrict
                    }}. อ.{{ item.district }}. จ.{{ item.provinces }}.
                    {{ item.postalCode }}</v-col
                  >
                   <v-col class="pa-0 mb-2" v-if="item.supply === 'จัดส่ง' && item.parcelNumber"
                    >{{ $t("message.parcelNumber") }}: {{ item.parcelNumber }}
                  </v-col
                  >
                  <v-col class="pa-0 mb-2" v-if="item.supply === 'จัดส่ง' && item.Transport"
                    >{{ $t("message.transportationService") }}: {{ item.Transport }}
                  </v-col
                  >
                  <v-col class="pa-0 mb-2" v-if="item.supply === 'link_code' && item.parcelNumber !== null"
                    >{{ $t("message.type") }}:
                    <v-icon>mdi-barcode-scan</v-icon>
                    {{ $t("message.linkcode") }}</v-col
                  >
                  <v-col
                    class="pa-0 mb-2"
                    v-if="
                      item.supply === 'link_code' &&
                      !item.rewardCode.startsWith('http') && item.rewardCode.search('/') === -1
                    "
                  >
                    <v-text-field
                      v-model="item.rewardCode"
                      :append-icon="
                        item.rewardCode ? 'mdi-content-copy' : 'mdi-copy'
                      "
                      ref="textToCopy"
                      outlined
                      style="width: 220px"
                      dense
                      hide-details
                      @click:append="copyText()"
                    ></v-text-field>
                  </v-col>
                   <v-col
                    class="pa-0 mb-2"
                    v-if="
                      item.supply === 'link_code' &&
                      !item.rewardCode.startsWith('http') && item.rewardCode.search('/') !== -1
                    "
                  >
                    <v-text-field
                      v-model="item.rewardCode.split('/')[0]"
                      :append-icon="
                        item.rewardCode ? 'mdi-content-copy' : 'mdi-copy'
                      "
                      ref="textToCopy"
                      outlined
                      style="width: 220px"
                      dense
                      hide-details
                      @click:append="copyText()"
                    ></v-text-field>
                    <v-text-field
                      v-model="item.rewardCode.split('/')[1]"
                      :append-icon="
                        item.rewardCode ? 'mdi-content-copy' : 'mdi-copy'
                      "
                      ref="textToCopy"
                      outlined
                      style="width: 220px"
                      dense
                      hide-details
                      @click:append="copyText()"
                    ></v-text-field>
                  </v-col>
                  <!-- <v-col
                    class="pa-0 mb-2"
                    v-if="
                      item.supply === 'link_code' &&
                      !item.rewardCode.startsWith('http')
                    "
                    ><v-btn color="primary" fab x-small dark @click="copyText"
                      ><v-icon>mdi-content-copy</v-icon></v-btn
                    ></v-col> -->
                  <v-col
                    class="pa-0 mb-2"
                    v-if="
                      item.supply === 'link_code' &&
                      item.rewardCode.startsWith('http')
                    "
                    ><a :href="item.rewardCode"
                      >*{{ item.rewardCode }}</a
                    ></v-col
                  >
                  <v-col
                    class="pa-0 mb-2"
                    v-if="
                      item.supply === 'link_code' &&
                      item.rewardCode.startsWith('http')
                    "
                    >{{ $t("message.presslink") }}</v-col
                  >
                  <v-col
                    class="pa-0 mb-1"
                    v-if="item.supply === 'รับหน้าร้าน' || item.supply === null"
                    >
                    <v-icon class="pb-1">mdi-store</v-icon>{{ item.shopId === 'U2ad4ca7a5c84fbe7358b56f54af919fa' ? 'รับที่สำนักงานโครงการ' : $t("message.ReceiveAtStore") }}</v-col
                  >
                  <v-col class="pl-0 pt-0 pb-1 font16 icon2 mb-1"
                    >{{ $t("message.redeemDate") }}: {{ format_date_thai(item.useDate.split(' ').slice(0, -1)) }}</v-col
                  >
                  <v-col
                    class="pa-0 icon2 mt-1"
                    v-if="
                      item.supply === 'จัดส่ง' && item.sendStatus === 'รอจัดส่ง'
                    "
                    ><v-chip small color="red" dark> {{ $t("message.waitDelivery") }}</v-chip></v-col
                  >
                  <v-col
                    class="pa-0 icon2 mt-1"
                    v-if="
                      item.supply === 'จัดส่ง' && item.sendStatus !== 'รอจัดส่ง'
                    "
                    ><v-chip small color="green" dark>{{ $t("message.alreadyShip") }}</v-chip></v-col
                  >
                  <v-col
                    class="pa-0 mt-1"
                    v-if="item.supply === 'รับหน้าร้าน' || item.supply === null"
                    ><v-chip small color="green" dark>{{ $t("message.received") }}</v-chip></v-col
                  >
                  <v-col class="pa-0 mt-1" v-if="item.supply === 'link_code'"
                    ><v-chip small color="green" dark>{{ $t("message.received") }}</v-chip></v-col
                  >
                </div>
              </v-col>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <v-divider></v-divider>
      </v-card>
    </v-dialog>

    <v-row no-gutters>
      <v-dialog
      v-model="dialogPolicy"
      width="500"
    >
      <v-card>
        <v-card-title class="bold headline2">
          {{ $t("message.policy") }}
        </v-card-title>

        <v-card-text class="pa-5">
          <div class="mb-3">
                      <div style="display: flex">
                      <v-checkbox hide-details v-model="checkTerm1"  @click.stop>
                      </v-checkbox>
                      <template>
                          <div  @click="dialogTerm1 = true" style="align-self: center;padding-top: 15px;">
                            {{ $t("message.condition") }}
                              <template>
                                <a  href="#"
                                  @click = "openPrivacyNotice">
                                  {{ $t("message.policy") }}
                                </a>
                              </template>
                          </div>
                        </template>
                      </div>
                      <v-checkbox hide-details v-model="checkTerm2"  @click.stop>
                        <template  v-slot:label>
                          <div>
                            {{ $t("message.condition2") }} {{shopname}}
                          </div>
                        </template>
                      </v-checkbox>
                    </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            :color="$bgColor"
            dark
            @click="dialogPolicy = false, upDatePDPA()"
          >
            I accept
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
      <v-col>
        <span
          style="position: absolute; top: 15px; right: 20px; z-index: 10"
          class="bold"
        >
          <v-chip class="ma-2" color="#dddddd" style="font-size:12px">
            {{ level.name }}
          </v-chip>
        </span>
        <div class="pa-3" :style="'background-image: linear-gradient(291deg,' + $bgColor3 + '0%,' + $bgColor3 + '100%)'">
          <v-fade-transition mode="out-in">
            <v-img :src="level.pictureUrl" max-height="220">
              <div>
                <div
                  style="
                    position: absolute;
                    bottom: 110px;
                    left: 20px;
                    display: flex;
                    align-items: center;
                  "
                >
                  <p

                    style="
                      font-weight: bold;
                      font-size: 24px;
                      margin-bottom: 10px;
                      color: white;
                    "
                    v-if="nextlevel"
                  >
                    {{ shopId !== 'Ub067d158c52aaaec79b67cfc997fda79' ?  formatNumber(member.collectPoint) : formatNumber(member.currentPoint) + ' ' +$t("message.point")}}
                    <!-- {{ formatNumber(member.collectPoint) }}/ -->
                  </p>
                  <p
                    style="
                      font-weight: bold;
                      font-size: 24px;
                      margin-bottom: 10px;
                      color: white;
                    "
                    v-if="!nextlevel"
                  >
                  {{ shopId !== 'Ub067d158c52aaaec79b67cfc997fda79' ?  formatNumber(member.collectPoint) : formatNumber(member.currentPoint) + $t("message.point")}}
                  </p>
                  <!-- <p
                    style="
                      font-weight: bold;
                      font-size: 24px;
                      margin-bottom: 10px;
                      color: white;
                    "
                    v-if="member.currentPoint === 0"
                  >
                    {{ member.collectPoint }}/
                  </p> -->
                  <p
                    v-if="nextlevel !== null && shopId !== 'Ub067d158c52aaaec79b67cfc997fda79'"
                    style="
                      font-weight: bold;
                      margin-bottom: 10px;
                      color: #871b12ff;
                      padding-top: 8px;
                      color: white;
                    "
                  >
                    {{ formatNumber(point) }}
                  </p>
                  <img
                    v-if="profile.pictureUrl && !$isTargetShop()"
                    style="
                      border-color: white;
                      height: 30px;
                      margin-left:5px;
                      padding-bottom: 9px;
                    "
                    alt="Avatar"
                    :src="require('@/assets/coin.png')"
                  />
                  <img
                  v-else
                  class="ps-1"
                  style="
                    border-color: white;
                    height: 20px;
                    margin-right: 4px;
                  "
                  alt="Avatar"
                  :src="require('@/assets/DimondWhite.svg')"
                />
                  <p
                    style="
                      position: absolute;
                      width: 300px;
                      bottom: -35px;
                      text-align: left;
                      color: #871b12ff;
                      font-size: 13px;
                      color: white;
                    "
                    v-if="!nextlevel"
                  >
                  {{ $t("message.memberHightLevel") }}
                  </p>
                  <p
                    style="
                      position: absolute;
                      width: 300px;
                      bottom: -35px;
                      text-align: left;
                      color: #871b12ff;
                      font-size: 13px;
                      color: white;
                    "
                    v-if="nextlevel && shopId !== 'Ub067d158c52aaaec79b67cfc997fda79'"
                  >
                  {{ $t("message.collectMore") }}
                    {{ formatNumber(point - member.collectPoint) }} {{ $t("message.point") }}
                  </p>
                  <p
                    style="
                      position: absolute;
                      width: 300px;
                      bottom: -50px;
                      text-align: left;
                      color: #871b12ff;
                      font-size: 13px;
                      color: white;
                    "
                    v-if="nextlevel && shopId !== 'Ub067d158c52aaaec79b67cfc997fda79'"
                  >
                  {{ $t("message.levelUp") }} {{ nextlevel.name }}
                  </p>
                </div>
                <div class="test" v-if="shopId !== 'Ub067d158c52aaaec79b67cfc997fda79'">
                  <v-progress-linear
                    style="position: absolute; bottom: 110px"
                    height="5"
                    rounded
                    background-color="#EEEEEE"
                    color="green"
                    :value="valueInprogress"
                  >
                  </v-progress-linear>
                </div>
                <div
                  style="
                    position: absolute;
                    bottom: -19px;
                    width: 100%;
                    height: 32%;
                    margin-bottom: 0;
                    right:-8px;
                  "
                  @click="$router.push('/level')"
                >
                  <p
                    style="
                      color: white;
                      margin-bottom: 0;
                      margin-top: 7px;
                      position: absolute;
                      left: 10px;
                    "
                  >
                  {{ $t("message.privilegeDetail") }}
                  </p>
                  <v-icon
                    style="
                      color: white;
                      margin-top: 4px;
                      position: absolute;
                      right: 20px;
                      margin-top: 7px;
                    "
                    >mdi-chevron-right</v-icon
                  >
                </div>
              </div>
            </v-img>
          </v-fade-transition>
        </div>
      </v-col>
    </v-row>
    <!-- <p style="color: red; text-align: center; margin-bottom: 10px">
      * คะแนนปัจจุบันยังไม่รวมกับคะแนนค่าใช้จ่ายในวันนี้
    </p> -->
    <!-- <div style="height: 80px;margin-top: 20px;"> -->
    <!-- <v-sheet class="mx-auto" elevation="5" max-width="800">
      <p style="margin-bottom: 0; padding-left: 15px">{{AllExpireCoinThisYear}} coin expire in {{new Date().getFullYear()}}</p>
      <v-slide-group active-class="success">
        <v-slide-item v-for="(item, n) in month" :key="n">
          <v-card
            color="#FFAFAF"
            class="ma-3"
            height="60"
            width="150"
          >
            <v-col class="pt-1" align="center" justify="center">
                <strong>{{ item.month }}</strong>
                <div style="font-weight: bold;">{{ item.total + ' coin'}}</div>
            </v-col>
          </v-card>
        </v-slide-item>
      </v-slide-group>
    </v-sheet> -->
    <!-- </div> -->
    <div class="pa-3 pt-6 pb-0">
      <v-sheet class="pa-3" style="margin-bottom: 15px;border-radius: 15px" elevation="1">
        <v-row>
          <v-col style="text-align: center;font-weight: bold;padding-bottom: 0px;"
            ></v-col
          >
        </v-row>
        <!-- <v-row v-if="member">
          <v-col :style="'color:' + $bgColor"
            class="weight1000 text-center pa-0 mb-3"
            >
            <img
                    v-if="profile.pictureUrl"
                    style="
                      border-color: white;
                      height: 30px;
                    "
                    alt="Avatar"
                    :src="require('@/assets/coin.png')"
                  />
            </v-col>
        </v-row> -->
        <div>
        <v-row >
          <v-col cols="7" class="pt-2 pb-0 pr-0">
            {{ $t("message.expirePoint") }} <strong :style="'color:' + $bgColor">{{new Date().getFullYear()}}</strong>
          </v-col>
          <v-col cols="5" align="right" class="pt-2 pb-0 pl-0 pr-0" style="padding-right: 17px !important">
            <strong :style="'color:' + $bgColor">{{formatNumber(AllExpireCoinThisYear)}}</strong> {{ $t("message.point") }}
          </v-col>
          <v-col cols="12">
              <Dialog :month="month"/>
          </v-col>
        </v-row>
              <v-divider></v-divider>
        <v-row>
          <v-col cols="7" class="pt-2 pb-0 pr-0">
            {{ $t("message.expirePoint") }} <strong :style="'color:' + $bgColor">{{new Date().getFullYear()+1}}</strong>
          </v-col>
          <v-col cols="5" align="right" class="pt-2 pb-0 pl-0 pr-0" style="padding-right: 17px !important">
            <strong :style="'color:' + $bgColor">{{formatNumber(AllExpireCoinNextYear)}}</strong> {{ $t("message.point") }}
          </v-col>
          <v-col cols="12" class="pb-4">
              <Dialog1 :month1="month1" ref="modal1"/>
          </v-col>
        </v-row>
        </div>
      </v-sheet>
      <EnglishMunMun v-if="shopId === 'Ub7cbc419244731cdd682354dd0e57cef'" :allBookings="allBookings"/>
      </div>
      <div class="pa-3 pt-4">
        <div style="display: flex; flex-wrap: wrap; justify-content: space-between; align-items: stretch; gap: 10px;">

          <!-- การ์ดที่ 1 -->
          <div
          @click="$router.push('/NewMyReward').catch(()=>{})"
          :style="'display: flex; flex-direction: column; flex-basis: calc(50% - 5px); max-width: calc(50% - 5px); padding: 10px; border-radius: 10px; height: auto; background-image: linear-gradient(0deg,' + $bgColor + ' 0%,' + $bgColor2 + ' 100%);'"
        >
          <div style="flex-grow: 1;">
            <img
              style="border-color: white; height: 40px; margin-bottom: 6px;"
              alt="Avatar"
              :src="require('@/assets/gift.png')"
            />
            <p class="mb-0" :style="'color:' + $textcolor">{{ $t("message.myReward") }}</p>
          </div>
          <div class="text-caption" :style="$isTargetShop() ? {fontFamily: 'Cordia New', color: $textcolor} : {fontFamily: 'kanit', fontWeight: 'bold', color: $textcolor}">
            {{ $t("message.view") }}
            <v-icon :style="'font-size: 15px; margin-left: 5px; color:' + $textcolor">
              mdi-chevron-right-circle-outline
            </v-icon>
          </div>
        </div>
          <!-- การ์ดที่ 2 -->
          <div
          v-if="formatNumber(myPackageCount) > 0"
            @click="$router.push('/MyPackage').catch(()=>{})"
            :style="'display: flex; flex-direction: column; flex-basis: calc(50% - 5px); max-width: calc(50% - 5px); padding: 10px; border-radius: 10px; height: auto; background-image: linear-gradient(0deg,' + $bgColor + ' 0%,' + $bgColor2 + ' 100%);'"
          >
          <div style="flex-grow: 1;">
            <img
              style="border-color: white; height: 40px; margin-bottom: 6px;"
              alt="Avatar"
              :src="require('@/assets/package.png')"
            />
            <p class="mb-0" :style="'color:' + $textcolor">{{ $t("message.privileges") }}</p>
            </div>
            <div class="text-caption" :style="$isTargetShop() ? {fontFamily: 'Cordia New', color: $textcolor} : {fontFamily: 'kanit', fontWeight: 'bold', color: $textcolor}">
              {{ $t("message.view") }}
              <v-icon :style="'font-size: 15px; margin-left: 5px; color:' + $textcolor">
                mdi-chevron-right-circle-outline
              </v-icon>
            </div>
          </div>

          <!-- การ์ดที่ 3 -->
          <div
            @click="$router.push('/tierBenefit').catch(()=>{})"
            :style="'display: flex; flex-direction: column; flex-basis: calc(50% - 5px); max-width: calc(50% - 5px); padding: 10px; border-radius: 10px; height: auto; background-image: linear-gradient(0deg,' + $bgColor + ' 0%,' + $bgColor2 + ' 100%);'"
          >
          <div style="flex-grow: 1;">
            <img
              style="border-color: white; height: 40px; margin-bottom: 6px;"
              alt="Avatar"
              :src="require('@/assets/crown.png')"
            />
            <p class="mb-0" :style="'color:' + $textcolor">{{ $t("message.allLevel") }}</p>
            </div>
            <div class="text-caption" :style="$isTargetShop() ? {fontFamily: 'Cordia New', color: $textcolor} : {fontFamily: 'kanit', fontWeight: 'bold', color: $textcolor}">
              {{ $t("message.view") }}
              <v-icon :style="'font-size: 15px; margin-left: 5px; color:' + $textcolor">
                mdi-chevron-right-circle-outline
              </v-icon>
            </div>
          </div>

          <!-- การ์ดที่ 4 -->
          <div
            @click="$router.push('/transaction').catch(()=>{})"
            :style="'display: flex; flex-direction: column; flex-basis: calc(50% - 5px); max-width: calc(50% - 5px); padding: 10px; border-radius: 10px; height: auto; background-image: linear-gradient(0deg,' + $bgColor + ' 0%,' + $bgColor2 + ' 100%);'"
          >
          <div style="flex-grow: 1;">
            <img
              style="border-color: white; height: 40px; margin-bottom: 6px;"
              alt="Avatar"
              :src="require('@/assets/payment.png')"
            />
            <p class="mb-0" :style="'color:' + $textcolor">{{ $t("message.pointHistory") }}</p>
            </div>
            <div class="text-caption" :style="$isTargetShop() ? {fontFamily: 'Cordia New', color: $textcolor} : {fontFamily: 'kanit', fontWeight: 'bold', color: $textcolor}">
              {{ $t("message.view") }}
              <v-icon :style="'font-size: 15px; margin-left: 5px; color:' + $textcolor">
                mdi-chevron-right-circle-outline
              </v-icon>
            </div>
          </div>

          <!-- การ์ดที่ 5 -->
          <div
            @click="dialogPolicy = true"
            :style="'display: flex; flex-direction: column; flex-basis: calc(50% - 5px); max-width: calc(50% - 5px); padding: 10px; border-radius: 10px; height: auto; background-image: linear-gradient(0deg,' + $bgColor + ' 0%,' + $bgColor2 + ' 100%);'"
          >
          <div style="flex-grow: 1;">
            <img
              style="border-color: white; height: 40px; margin-bottom: 6px;"
              alt="Avatar"
              :src="require('@/assets/terms-and-conditions.png')"
            />
            <p class="mb-0" :style="'color:' + $textcolor">{{ $t("message.policy") }}</p>
            </div>
            <div class="text-caption" :style="$isTargetShop() ? {fontFamily: 'Cordia New', color: $textcolor} : {fontFamily: 'kanit', fontWeight: 'bold', color: $textcolor}">
              {{ $t("message.view") }}
              <v-icon :style="'font-size: 15px; margin-left: 5px; color:' + $textcolor">
                mdi-chevron-right-circle-outline
              </v-icon>
            </div>
          </div>

          <!-- การ์ดที่ 6 -->
          <div
            @click="getHistory() === true"
            :style="'display: flex; flex-direction: column; flex-basis: calc(50% - 5px); max-width: calc(50% - 5px); padding: 10px; border-radius: 10px; height: auto; background-image: linear-gradient(0deg,' + $bgColor + ' 0%,' + $bgColor2 + ' 100%);'"
          >
          <div style="flex-grow: 1;">
            <img
              style="border-color: white; height: 40px; margin-bottom: 6px;"
              alt="Avatar"
              :src="require('@/assets/gift-list.png')"
            />
            <p class="mb-0" :style="'color:' + $textcolor">{{ $t("message.rewardHistory") }}</p>
            </div>
            <div class="text-caption" :style="$isTargetShop() ? {fontFamily: 'Cordia New', color: $textcolor} : {fontFamily: 'kanit', fontWeight: 'bold', color: $textcolor}">
              {{ $t("message.view") }}
              <v-icon :style="'font-size: 15px; margin-left: 5px; color:' + $textcolor">
                mdi-chevron-right-circle-outline
              </v-icon>
            </div>
          </div>

        </div>
      </div>

    <!-- <v-container class="pt-0">
      <my-rewards></my-rewards>
    </v-container> -->
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import MenuItem from '../MenuItem'
import MyRewards from '../MyRewards'
import moment from 'moment'
import Dialog from './Expiredialog'
import Dialog1 from './Expiredialog1'
import axios from 'axios'
import EnglishMunMun from './EnglishMunMun'

export default {
  name: 'Card',
  components: {
    'menu-item': MenuItem,
    'my-rewards': MyRewards,
    Dialog,
    Dialog1,
    EnglishMunMun
  },
  data () {
    return {
      myPackageCount: 0,
      allBookings: null,
      noDataMessage: null,
      allDataLoaded: false,
      checkTerm1: null,
      checkTerm2: null,
      dialog: false,
      dialogPolicy: false,
      member: null,
      level: null,
      rewards: null,
      nextlevel: null,
      valueInprogress: null,
      point: 0,
      dialogRewardhistory: false,
      expire: null,
      expire1: null,
      AllExpireCoinThisYear: null,
      AllExpireCoinNextYear: null,
      myPackage: false,
      month: [
        { numMonth: '01', month: 'January', total: 0 },
        { numMonth: '02', month: 'February', total: 0 },
        { numMonth: '03', month: 'March', total: 0 },
        { numMonth: '04', month: 'April', total: 0 },
        { numMonth: '05', month: 'May', total: 0 },
        { numMonth: '06', month: 'June', total: 0 },
        { numMonth: '07', month: 'July', total: 0 },
        { numMonth: '08', month: 'August', total: 0 },
        { numMonth: '09', month: 'September', total: 0 },
        { numMonth: '10', month: 'October', total: 0 },
        { numMonth: '11', month: 'November', total: 0 },
        { numMonth: '12', month: 'December', total: 0 }
      ],
      month1: [
        { numMonth: '01', month: 'January', total: 0 },
        { numMonth: '02', month: 'February', total: 0 },
        { numMonth: '03', month: 'March', total: 0 },
        { numMonth: '04', month: 'April', total: 0 },
        { numMonth: '05', month: 'May', total: 0 },
        { numMonth: '06', month: 'June', total: 0 },
        { numMonth: '07', month: 'July', total: 0 },
        { numMonth: '08', month: 'August', total: 0 },
        { numMonth: '09', month: 'September', total: 0 },
        { numMonth: '10', month: 'October', total: 0 },
        { numMonth: '11', month: 'November', total: 0 },
        { numMonth: '12', month: 'December', total: 0 }
      ],
      profile: null,
      shopId: null,
      shopname: null,
      rewardHistory: null
    }
  },
  // eslint-disable-next-line space-before-function-paren
  async mounted() {
    // console.log('mountedcard')
    this.shopId = this.GET_SHOPID()
    this.profile = this.getLiffProfile()
    if (this.$route.query.shopId) {
      if (typeof this.$session.getAll().shopId === 'undefined') {
        this.$session.remove('shopId')
        this.$session.start()
        this.$session.set('shopId', this.$route.query.shopId)
      }
    }
    if (this.shopId === 'Ub7cbc419244731cdd682354dd0e57cef') {
      this.getBookingView()
    }
    await this.getPackage()
    await this.prepareData()
    await this.getExpireDate()
    // await this.getPackLog()
    if (this.$route.query.openHistory) {
      await this.getHistory()
    }
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    })
  },
  methods: {
    ...mapGetters('lineStore', ['liffIsReady', 'getLiffProfile']),
    ...mapGetters('memberStore', ['GET_MEMBERINFO']),
    ...mapGetters('shopStore', ['GET_SHOPID']),
    ...mapActions('memberStore', ['getMemberProfile']),

    copyText () {
      let textToCopy = this.$refs.textToCopy[0].$el.querySelector('input')
      textToCopy.select()
      document.execCommand('copy')
    },
    async getBookingView () {
      try {
        const response = await axios.get(`${this.DNS_Link}/booking_view/get`, {
          params: {
            shopId: this.shopId,
            userId: this.profile.userId
          }
        })


        if (!response.data) {
          throw new Error('No response data')
        }

        if (!Array.isArray(response.data)) {
          this.noDataMessage = response.data.message || 'No data available'
          this.allDataLoaded = true
          return
        }

        const bookings = response.data
        const statusMapping = {
          confirm: { status: 'ยืนยัน', color: '#4CAF50' },
          // eslint-disable-next-line camelcase
          confirmJob: (RECORD_STATUS_Job) => {
            // eslint-disable-next-line camelcase
            if (RECORD_STATUS_Job === 'N') {
              return { status: 'ยังไม่ปิดงาน', color: '#2196F3' }
              // eslint-disable-next-line camelcase
            } else {
              return { status: 'จบงาน', color: '#3F51B5' }
            }
          },
          cancel: { status: 'ยกเลิก', color: '#F44336' },
          default: { status: 'รอยืนยัน', color: '#FFB74D' }
        }

        const newBookings = bookings.map(item => {
          // eslint-disable-next-line camelcase
          const { statusBt, RECORD_STATUS_Job, flowName, dueDateTextDay, timeText, masBranchName, bookingDataCustomerName, bookingDataCustomerTel, remark, depositImge, hangoutLink } = item
          // const { status, color } = statusMapping[statusBt] || statusMapping.default
          let status, color
          if (statusBt === 'confirmJob') {
            ({ status, color } = statusMapping.confirmJob(RECORD_STATUS_Job))
          } else {
            ({ status, color } = statusMapping[statusBt] || statusMapping.default)
          }
          // console.log(item)
          return {
            status,
            color,
            title: flowName,
            day: this.convertDate(dueDateTextDay),
            time: timeText,
            branch: masBranchName,
            name: bookingDataCustomerName,
            phone: bookingDataCustomerTel,
            note: remark,
            linkMeet: hangoutLink,
            link: depositImge
          }
        })

        this.allBookings = newBookings
        this.displayedBookings = this.allBookings.slice(0, this.currentPage * this.itemsPerPage)

        if (newBookings.length < this.itemsPerPage) {
          this.allDataLoaded = true
        }
      } catch (error) {
        console.error('Error fetching booking view:', error.message)
      }
    },
    convertDate (dateString) {
      const buddhistYearFormat = 'DD MMM YYYY'
      const date = moment(dateString, 'DD/MM/YYYY').locale('th')
      return date.format(buddhistYearFormat).replace(/(\d{4})/, (match) => (parseInt(match) + 543))
    },
    // formatPhoneNumber (phoneNumber) {
    //   try {
    //     // Remove any non-digit characters
    //     const digits = phoneNumber.replace(/\D/g, '')
    //     // Split the digits into the desired format
    //     const formattedNumber = ${digits.slice(0, 3)} ${digits.slice(3)}

    //     return formattedNumber
    //   } catch (error) {
    //     console.log(error)
    //     console.log(phoneNumber)
    //     return phoneNumber || '-'
    //   }
    // },
    async prepareData () {
      this.member = this.GET_MEMBERINFO()
      // console.log('this.member', this.member)

      this.checkTerm1 = this.member.CONDITION_TERM1
      this.checkTerm2 = this.member.CONDITION_TERM2
      if (this.checkTerm1 !== null) {
        this.checkTerm1 = (this.member.CONDITION_TERM1.toLowerCase() === 'true')
      }
      if (this.checkTerm2 !== null) {
        this.checkTerm2 = (this.member.CONDITION_TERM2.toLowerCase() === 'true')
      }
      // console.log('this.checkTerm2', this.checkTerm2)
      await this.getOnlyShop()
      // console.log('his.checkTerm1', this.checkTerm1)
      await this.getLevelDB()
      // console.log('cardLevel', this.level)
      // console.log('this.member', this.member)
      // await this.getMyReward()
      this.level.sort((a, b) => {
        return b.point - a.point
      })
      this.level.map((row) => {
        if (this.member.collectPoint < row.point) {
          this.nextlevel = row
        }
      })
      // console.log('nextlevel', this.nextlevel)
      if (this.nextlevel) {
        this.point = this.nextlevel.point
      } else {
      }
      this.level = this.level.filter(
        (item) => parseInt(item.levelId) === parseInt(this.member.levelId)
      )[0]
      if (this.nextlevel && this.member.collectPoint > 0) {
        this.valueInprogress = (
          (this.member.collectPoint * 100) /
        this.nextlevel.point
        ).toFixed(2)
      }
    },
    openPrivacyNotice () {
      window.open(window.location.origin + '/PrivacyNotice', '_blank').focus()
    },
    async getHistory () {
      const result = await this.callBeTaskAPI(
        'get',
        '/rewardCode/lineHistory/get?redeemStatus=use'
      )
      if (result) {
        if (Array.isArray(result)) {
          this.rewardHistory = result
        }
      }
      this.dialogRewardhistory = true
    },
    async getMyReward () {
      const result = await this.callBeTaskAPI(
        'get',
        `/rewardCode/line/get?redeemStatus=get`
      )
      if (Array.isArray(result)) {
        this.rewards = result
      }
    },
    async upDatePDPA () {
      await this.callBeTaskAPI(
        'post',
        `/member/edit/${this.member.memberId}`,
        {CONDITION_TERM1: this.checkTerm1, CONDITION_TERM2: this.checkTerm2}
      )
      this.getMemberProfile()
    },
    async getLevelDB () {
      const result = await this.callBeTaskAPI(
        'get',
        '/level/line/get?RECORD_STATUS=N'
      )
      if (result) {
        if (result.length > 0) {
          this.level = result
          this.allLevel = result
          return result
        }
      }
    },
    async getOnlyShop () {
      const result = await this.callBeTaskAPI(
        'get',
        `/only_shop/get?shopId=${this.shopId}`
      )
      if (result) {
        if (Array.isArray(result)) {
          this.shopname = result[0].name
        }
      }
    },
    async getExpireDate () {
      const d = new Date()
      let ThisYear = d.getFullYear()
      let Nextyear = d.getFullYear() + 1
      const result2 = []
      const result3 = []
      const result = await this.callBeTaskAPI(
        'get',
        `/get-expired-date/get?memberId=${this.profile.memberId}&shopId=${this.shopId}`
      )
      if (Array.isArray(result)) {
        this.expire = result.map((item) => {
          return {
            expire: moment.unix(item.expireDate).format('MM/YYYY'),
            balanceExpire: item.balancePoint,
            year: moment.unix(item.expireDate).format('YYYY')
          }
        }).filter((item) => { return item.year === ThisYear.toString() })

        this.expire1 = result.map((item) => {
          return {
            expire: moment.unix(item.expireDate).format('MM/YYYY'),
            balanceExpire: item.balancePoint,
            year: moment.unix(item.expireDate).format('YYYY')
          }
        }).filter((item) => { return item.year === Nextyear.toString() })
      }
      if (this.expire) {
        this.expire.reduce((res, value) => {
          if (!res[value.expire]) {
            res[value.expire] = {
              month: value.expire.split('/')[0],
              year: value.expire.split('/')[1],
              balanceExpire: 0
            }
            result2.push(res[value.expire])
          }
          res[value.expire].balanceExpire += value.balanceExpire
          return res
        }, {})
      }
      if (this.expire1) {
        this.expire1.reduce((res, value) => {
          if (!res[value.expire]) {
            res[value.expire] = {
              month: value.expire.split('/')[0],
              year: value.expire.split('/')[1],
              balanceExpire: 0
            }
            result3.push(res[value.expire])
          }
          res[value.expire].balanceExpire += value.balanceExpire
          return res
        }, {})
      }
      this.AllExpireCoinThisYear = result2.reduce((accum, obj) => accum + obj.balanceExpire, 0)
      this.AllExpireCoinNextYear = result3.reduce((accum, obj) => accum + obj.balanceExpire, 0)
      for (const element of this.month) {
        for (const a of result2) {
          if (element.numMonth === a.month) {
            element.total = a.balanceExpire
          }
        }
      }
      for (const element of this.month1) {
        for (const a of result3) {
          if (element.numMonth === a.month) {
            element.total = a.balanceExpire
          }
        }
      }
    },
    async getPackLog () {
      const result = await this.callBeTaskAPI(
        'get',
        `/PackageLog/get?userId=${this.profile.userId}&shopId=${this.shopId}`
      )
      if (Array.isArray(result)) {
        this.myPackage = true
      }
    },
    async getPackage () {
      const result = await this.callBeTaskAPI(
        'get',
        `/PackageLog/getCount?memberId=${this.profile.memberId}&shopId=${this.shopId}`
      )
      if (Array.isArray(result)) {
        this.myPackageCount = result[0].count
      }
    }
  }
}
</script>
<style scoped>
.card {
  height: 200px;
  overflow: hidden;
}
.cardbg {
  background-repeat: no-repeat !important;
  background-size: 90% 110% !important;
  background-attachment: fixed;
  background-position: center;
}
.v-progress-linear {
  width: 90%;
}
.test {
  padding-left: 20px;
}
html,
body {
  width: 100%;
  overflow-x: hidden;
}
.text-gradient {
   background: linear-gradient(to right, #000000, #52057B,#892CDC,#BC6FF1);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.v-input--hide-details>.v-input__control>.v-input__slot {
  margin-bottom: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/Card/Main.vue